<template>
  <div>
    <b-table
      head-variant="light"
      ref="general-table"
      class="vuetable bklMtable"
      id="table-transition-example"
      :items="items"
      align="center"
      stacked 
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      primary-key="bookingNo"
      responsive
      show-empty
    >
    <template v-slot:cell(visitorName)="row">
      <div @click="onClickRow(row.item , row.item.bookingNo , $event.target)" class="mNewDiv">
        <div>예약자</div>
        <div>{{ row.item.visitorName }}</div>
      </div>
    </template>
      <template v-slot:cell(headcount)="row">
        <div @click="onClickRow(row.item , row.item.bookingNo , $event.target)" class="mNewDiv">
            <div>인원</div>
            <div>{{Number(row.item.adultHeadcount) +Number(row.item.childHeadcount) + Number(row.item.babyHeadcount)+'명' }}</div>
        </div>
      </template>

      <template v-slot:cell(reservationDate)="row">
        <div @click="onClickRow(row.item , row.item.bookingNo , $event.target)" class="mNewDiv">
          <div>방문예정일</div>
          <div>{{$moment(row.item.reservationDate).format('YYYY-MM-DD HH:mm')}}</div>
        </div>
      </template>

      <template v-slot:cell(visitorRequests)="row">
          <div @click="onClickRow(row.item , row.item.bookingNo , $event.target)" class="mNewDiv">
            <div>
              요청사항
            </div>
            <div v-if="row.item.visitorRequests != null && row.item.visitorRequests != ''" >
              ○
            </div>
            <div v-else>
              X
            </div>
          </div>
      </template>

      <template v-slot:empty="row">
        <h5 style="text-align: center; font-weight: lighter">조회된 예약 목록이 없습니다.</h5>
      </template>


    </b-table>
  </div>
</template>


<script>

  import {
    mapGetters,
  } from "vuex";

  import '../../../../assets/css/custom/common.css'
  import {getBookingStatusText} from "../../../../utils";

  export default {
    components: {},
    props: ['items', 'fields', 'currentPage', 'perPage'],
    data() {
      return {
        // allCheck: false
      }
    },
    mounted() {
    },
    computed: {
      ...mapGetters(['siteName']),
    },
    methods: {
      getBookingStatusText,

      onClickRow(item, bookingNo, target) {
        this.$emit('click-row', item, bookingNo)
      },
      onCancelVisit(item, bookingNo, target) {
        this.$emit('visited-cancel', item, bookingNo)
      },
      confirmProc(bookingNo) {
        this.$emit('confirm-proc', bookingNo)
      }
      , denyProc(bookingNo) {
        this.$emit('deny-proc', bookingNo)
      },

      showReq(item) {
        this.$emit('showReq', item)

      },


    },
    watch: {
      // allCheck(chk) {
      //   this.items.forEach(function(value, index) {
      //     value.selected = chk
      //   })
      // }

    }

  }
</script>
